import { Checkbox, Dropdown, LoadingIndicator } from "../components/common";
import {CheckboxEvent, DropdownEvent} from "../components/event";
import { fetch as fetchPolyfill } from "whatwg-fetch";
import { Base, BaseConfiguration, Page } from "../services";
// import {SearchBarType, TalentsList} from "./TalentsList";

type SearchItem = {
    checked?: boolean,
    id?: number,
    axi_id?: number,
    level?: number,
    field_name?: string,
    parent_id?: number,
    parent_slug?: string,
    slug?: string,
    text?: string,
}


export type SearchBarConfiguration = BaseConfiguration & {
    taxonomy?: string,
};

export class SearchBar extends Base {
    static event = {
        DATA_READY: "searchbar:data::ready",
        REQUEST: "api:request",
    };

    protected configuration: SearchBarConfiguration;
    protected searchName: string;
    // protected searchDropdown: HTMLElement;
    protected searchDropdown: Dropdown;
    protected hierarchyCheckboxes: NodeListOf<HTMLElement>;
    protected autocompleteCheckboxes: NodeListOf<HTMLElement>;
    protected selectedCheckboxes: NodeListOf<HTMLElement>;
    protected checkboxes: Map<string, Checkbox>;
    protected dataItems: Array<SearchItem>;
    protected searchInput: HTMLInputElement;

    protected autocompleteListContainer: HTMLElement;
    protected selectedListContainer: HTMLElement;
    protected hierarchyListContainer: HTMLElement;

    protected autocompleteListElement: HTMLElement;
    protected autocompleteNoResultsElement: HTMLElement;
    protected selectedListElement: HTMLElement;
    protected hierarchyListElement: HTMLElement;

    protected inputSelected: HTMLInputElement;
    // protected list: TalentsList;
    protected loadingIndicator: LoadingIndicator;
    protected taxonomyName: string;

    constructor(...configurations: SearchBarConfiguration[])
    {
        const defaults: SearchBarConfiguration = {
            taxonomy: "",
        };

        super(defaults, ...configurations);

        this.handleDataReady = this.handleDataReady.bind(this);
        // this.handleLinkRelease = this.handleLinkRelease.bind(this);
        // this.handleSearchRelease = this.handleSearchRelease.bind(this);
        this.handleHierarchyCheckboxChange = this.handleHierarchyCheckboxChange.bind(this);
        this.handleSelectedCheckboxChange = this.handleSelectedCheckboxChange.bind(this);
        this.handleSearchResultsCheckboxChange = this.handleSearchResultsCheckboxChange.bind(this);
        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
        this.handleSearchInputBlur = this.handleSearchInputBlur.bind(this);
        this.handleSearchInputFocus = this.handleSearchInputFocus.bind(this);

        this.init();
    }

    public init(): void
    {
        this.checkboxes = new Map();
        this.on(SearchBar.event.DATA_READY, this.handleDataReady);

        this.getSearchDataRequest();

        /*
        this.loadingIndicator = new LoadingIndicator({
            container: this.container.querySelector(".b-SearchBar__main")
        });
        */
        // this.search.addEventListener("click", this.handleSearchRelease)
        // this.readUrl();
    }

    public getSearchDataRequest(): this
    {
        this.dataItems = [];

        this.request("get_search_data")
            .then(response =>
            {
                if ("data" in response)
                {
                    this.trigger(SearchBar.event.DATA_READY, {
                        data: response.data,
                    });
                }
            })
            .catch((error) =>
            {
                console.error("Error:", error);
            })
        ;

        return this;
    }

    public request(action: string): Promise<Response>
    {
        const data: FormData = new FormData();
        data.append( "action", action );
        data.append( "taxonomy", this.configuration.taxonomy );

        const options: object = {
            method: "POST",
            // credentials: "same-origin",
            body: data,
            /*
            headers: {
                "Content-Type": "application/json",
            },*/
        };

        return fetchPolyfill(
            "/wp-admin/admin-ajax.php",
            options)
            .then((response): Promise<Response> =>
            {
                return response
                    .text()
                    .then((text) =>
                    {
                        const data: any = text && JSON.parse(text);

                        if (!response.ok)
                        {
                            const error: any = (data && data.message) || response.statusText;
                            return Promise.reject(error);
                        }

                        return data;
                    });
            });

    }

    protected buildSearch(data: {name?:string, items?: []}): this
    {
        // this.searchDropdown = document.querySelector(`[data-searchbar="${data.name}"]`);

        if (!document.querySelector(`[data-searchbar="${data.name}"]`))
        {
            return this;
        }

        this.searchDropdown = new Dropdown
        ({
            html: document.querySelector(`[data-searchbar="${data.name}"]`)
        })
            .on(DropdownEvent.UNFOLD, (detail) => {
                if (this.searchInput)
                    this.searchInput.focus();
            })
            .on(DropdownEvent.FOLD, (detail) => {
                if (this.searchInput)
                    this.searchInput.value = "";
            })
        ;
        this.searchDropdown.removeClass("u-disabled");

        if (!this.searchDropdown)
            return this;

        this.inputSelected = this.searchDropdown.querySelector("input.m-SearchDropdown__input-selected");

        this.autocompleteListContainer = this.searchDropdown.querySelector(".m-SearchDropdown__autocomplete-container");
        this.autocompleteListElement = this.autocompleteListContainer.querySelector(".m-SearchDropdown__autocomplete");
        this.autocompleteNoResultsElement = this.autocompleteListContainer.querySelector(".m-SearchDropdown__autocomplete-noresults");
        this.autocompleteNoResultsElement.style.display = "none";

        this.selectedListContainer = this.searchDropdown.querySelector(".m-SearchDropdown__selected-container");
        this.selectedListElement = this.selectedListContainer.querySelector(".m-SearchDropdown__selected");

        this.hierarchyListContainer = this.searchDropdown.querySelector(".m-SearchDropdown__items-container");
        this.hierarchyListElement = this.hierarchyListContainer.querySelector(".m-SearchDropdown__items");

        this.hierarchyCheckboxes = this.hierarchyListElement.querySelectorAll(".m-SearchItem__checkbox");

        this.hierarchyCheckboxes.forEach((checkboxElement: HTMLElement) => {
            let checkbox: Checkbox = new Checkbox({
                html: checkboxElement,
            })
                .on(CheckboxEvent.AFTER_CHANGE, this.handleHierarchyCheckboxChange)
            ;

            const input: HTMLInputElement =  checkbox.getInput();

            this.checkboxes.set(
                input.getAttribute("data-id"),
                checkbox
            )
        });

        data.items.forEach((item: any) => {
            this.dataItems.push({
                id: parseInt(item.id),
                axi_id: parseInt(item.axi_id),
                checked: false,
                field_name: item.name || "",
                parent_slug: item.parent_slug,
                parent_id: parseInt(item.parent_id),
                slug: item.slug,
                text: item.text,
            });
        });

        this.searchInput = this.searchDropdown.querySelector(".c-Dropdown__field input");

        // this.searchInput.addEventListener("change", this.handleSearchInputChange);
        this.searchInput.addEventListener("input", this.handleSearchInputChange);
        this.searchInput.addEventListener("blur", this.handleSearchInputBlur);
        this.searchInput.addEventListener("focus", this.handleSearchInputFocus);
        // this.searchInput.addEventListener("keydown", this.__handleKeypress);
        // this.searchInput.addEventListener("paste", this.__handlePaste);

        // this.updateSearchFieldText(this.dropdownContract);
        this.getSelectedFromUrl();

        this.updateDropdownText();

        return this;
    }


    protected getSelectedFromUrl(): this {

        let locationsParam: string = Page.getUrlParameter("locations");

        if (!locationsParam)
            return this;

        const locationsIds: Array<number> = locationsParam.split(',').map(Number);

        console.log(locationsIds);

        const inputsSelector: Array<string> = locationsIds.map((id: number) => {
           return  `.m-SearchItem__checkbox input[data-location-id="${id.toString()}"]`;
        });

        const inputs: NodeListOf<HTMLInputElement> = this.hierarchyListElement.querySelectorAll(inputsSelector.join(","));

        inputs.forEach((input: HTMLInputElement) => {
            const isChecked: boolean = true;
            input.checked = isChecked;
            const id: string = input.getAttribute("data-id");
            const hierarchyCheckbox: Checkbox = this.checkboxes.get(id);
            if (hierarchyCheckbox)
            {
                hierarchyCheckbox.setChecked(isChecked); //false
                this.updateChildrenAndAncestors(hierarchyCheckbox, isChecked);


                // this.updateItemData(parseInt(targetId), {checked: target.isChecked()});
                // this.updateChildrenAndAncestors(target, target.isChecked());
                this.updateSelectedChildrenIndicator(input);
                // this.updateDropdownText();

            }
        });

        this.updateSelectedItemsList();

        return this;
    }

    protected getSearchItems(): Array<SearchItem>
    {
        let items: Array<SearchItem> = [];

        if (!this.hierarchyCheckboxes)
            return [];

        this.hierarchyCheckboxes.forEach((checkboxField: HTMLElement) =>
        {
            const input: HTMLInputElement = checkboxField.querySelector("input");
            const textElement: HTMLElement = checkboxField.querySelector(".m-SearchItem__name");

            items.push({
                checked: input.checked,
                id: parseInt(input.getAttribute("data-id")),
                axi_id: parseInt(input.getAttribute("data-location-id")),
                field_name: input.name || "",
                parent_slug: input.getAttribute("data-parent") || "",
                parent_id: parseInt(input.getAttribute("data-parent-id")) || 0,
                slug: input.getAttribute("data-name"),
                text: textElement.textContent,
            });
        });

        return items;
    }

    protected getSelectedItems(): Array<SearchItem>
    {
        const items: Array<SearchItem> = this.getSearchItems();

        let selectedItems: Array<SearchItem> = items.filter((item: SearchItem) =>
        {
            return item.checked === true;
        });

        return selectedItems;
    }
/*
    protected getFiltersForList() : SearchBarType {
        const allFilters = this.getAllSelectedFilters();
        let filtersForList = {};

        filtersForList[SearchBar.fieldName.PROFESSION] = [];
        if (allFilters[SearchBar.fieldName.PROFESSION].length) {
            allFilters[SearchBar.fieldName.PROFESSION].forEach((filterItem: FilterItem) => {
                const filterToAdd = parseInt(filterItem.name.replace('filter_term_', ''));
                if (filterToAdd > 0) {
                    filtersForList[SearchBar.fieldName.PROFESSION].push(filterToAdd);
                }
            });
        }

        return filtersForList;
    }
*/
    protected buildSearchCheckbox(data: SearchItem): Checkbox
    {
        let checkbox: Checkbox = new Checkbox({
            text: data.text
        });

        checkbox.setChecked(data.checked, {silent: true })

        checkbox.setAttribute("data-item", data.slug);

        const input: HTMLInputElement = checkbox.getInput();

        if (data.field_name)
        {
            input.name = data.field_name;
        }

        input.setAttribute("data-name", data.slug);

        if (data.parent_slug)
        {
            input.setAttribute("data-parent", data.parent_slug);
        }
        if (data.parent_id)
        {
            input.setAttribute("data-parent-id", data.parent_id.toString());
        }

        if (data.axi_id)
        {
            input.setAttribute("data-location-id", data.axi_id.toString());
        }

        input.setAttribute("data-id", data.id.toString());

        return checkbox;
    }

    protected updateSelectedItemsList(): this
    {
        const selectedItems: Array<SearchItem> = this.getSelectedItems();

        //empty
        while (this.selectedListElement.lastChild)
            this.selectedListElement.removeChild(this.selectedListElement.lastChild);

        if (selectedItems.length == 0)
        {
            this.selectedListContainer.classList.add("m-SearchDropdown__list--empty");
            this.searchDropdown.removeClass("m-SearchDropdown--selected");
        }
        else
        {
            this.selectedListContainer.classList.remove("m-SearchDropdown__list--empty");
            this.searchDropdown.addClass("m-SearchDropdown--selected");
        }


        // add items
        selectedItems.forEach((selectedItem: SearchItem) => {

            let defaults: SearchItem =
                {
                    checked: selectedItem.checked,
                    // field_name: "sel_" + selectedItem.field_name // input name
                };

            const searchCheckbox: Checkbox = this.buildSearchCheckbox(Object.assign({}, selectedItem, defaults));

            searchCheckbox
                .on(CheckboxEvent.AFTER_CHANGE, this.handleSelectedCheckboxChange)
                .appendTo(this.selectedListElement)
            ;
        });

        this.updateInputSelected();

        return this;
    }

    protected updateInputSelected(): this
    {
        const selectedItems: Array<SearchItem> = this.getSelectedItems();
        let selectedIds: Array<number> = selectedItems.map((item: SearchItem) => item.axi_id);

        if (this.inputSelected)
        {
            this.inputSelected.value = selectedIds.join(",");

            if (selectedIds.length == 0)
            {
                this.searchInput.setAttribute("required", "");
            }
            else
            {
                this.searchInput.removeAttribute("required");
            }
        }

        return this;
    }

    public search(searchText: string): {starts_with: Array<SearchItem>, contains: Array<SearchItem>}
    {
        let basicItems: Array<SearchItem> = [];
        let additionalItems: Array<SearchItem> = [];

        basicItems = this.dataItems.filter((item: SearchItem) => {
            return item.text.toLowerCase().startsWith(searchText.toLowerCase());
        });

        additionalItems = this.dataItems.filter((item: SearchItem) => {
            return item.text.toLowerCase().includes(searchText.toLowerCase());
        });

        return {
            starts_with: basicItems, // result that starts with searched values
            contains: additionalItems // everything else
        };
    }

    protected addAutocompleteCheckbox(itemData: SearchItem, highlihtedText: string = ""): this
    {
        const parent: SearchItem = this.getItemDataById(itemData.parent_id);
        let itemText: string = itemData.text;

        if (highlihtedText)
        {
            const regEx: RegExp = new RegExp(highlihtedText, "ig");
            itemText = itemText.replace(regEx, `<b>$&</b>`); //back reference $& to preserve case
        }

        const details: string = parent ? `<small>${parent.text}</small>` : "";

        let defaults: SearchItem = {
            checked: itemData.checked,
            // field_name: "find_" + itemData.field_name, // input name
            text: itemText + details
        };

        const searchCheckbox: Checkbox = this.buildSearchCheckbox(Object.assign({}, itemData, defaults));

        searchCheckbox
            .on(CheckboxEvent.AFTER_CHANGE, this.handleSearchResultsCheckboxChange)
            .appendTo(this.autocompleteListElement)
        ;

        return this;
    }

    protected updateDropdownText(): this
    {
        const selectedItems: Array<SearchItem> = this.getSelectedItems();
        let newText: string = "";
        if (selectedItems.length)
        {
            newText = selectedItems.map(item => item.text).join(", ");
        }
        else
        {
            newText = this.searchDropdown.getInitialText();
        }

        this.searchDropdown.setText(newText);

        return this;
    }

    protected getItemDataById(id: number): SearchItem
    {
        return this.dataItems.find((item: SearchItem) => {
            return item.id === id;
        });
    }

    protected updateItemData(id: number, data: object = {}): this
    {
        const itemIndex: number = this.dataItems.findIndex((item: SearchItem) =>{
            return item.id === id;
        });
        this.dataItems[itemIndex] = Object.assign(this.dataItems[itemIndex], data);

        return this;
    }

    protected showAutocomplete(): this
    {
        this.selectedListContainer.style.display = "none";
        this.hierarchyListContainer.style.display = "none";
        this.autocompleteListContainer.style.display = "";

        return this;
    }

    protected maybeNoResultsInfo(resultsCount: number = 0): this
    {
        if (resultsCount)
            this.autocompleteNoResultsElement.style.display = "none";
        else
            this.autocompleteNoResultsElement.style.display = "";

        return this;
    }

    protected showHierarchyAndSelected(): this
    {
        this.selectedListContainer.style.display = "";
        this.hierarchyListContainer.style.display = "";
        this.autocompleteListContainer.style.display = "none";
        return this;
    }

    protected updateSearchResults(searchText: string, limit: number = 10): this
    {
        const searchResults: {starts_with: Array<SearchItem>, contains: Array<SearchItem>} = this.search(searchText);

        this.autocompleteListElement = this.searchDropdown.querySelector(".m-SearchDropdown__autocomplete");

        //empty
        while (this.autocompleteListElement.lastChild)
            this.autocompleteListElement.removeChild(this.autocompleteListElement.lastChild);

        if (searchText.length === 0)
        {
            this.showHierarchyAndSelected();
            this.autocompleteListContainer.classList.add("m-SearchDropdown__list--empty");

            return this;
        }

        this.autocompleteListContainer.classList.remove("m-SearchDropdown__list--empty");

        let addedIds: Array<number> = [];
        let addedCounter: number = 0;

        this.showAutocomplete();
        this.maybeNoResultsInfo(searchResults["starts_with"].length + searchResults["contains"].length);

        searchResults["starts_with"].every((selectedItem: SearchItem) => {
            if (!addedIds.includes(selectedItem.id))
            {
                this.addAutocompleteCheckbox(selectedItem, searchText);
                addedIds.push(selectedItem.id);
                addedCounter++;
            }

            if (addedCounter >= limit)
            {
                return false;
            }

            return true;
        });

        if (addedCounter < limit)
        {
            searchResults["contains"].every((selectedItem: SearchItem) =>
            {

                if (!addedIds.includes(selectedItem.id))
                {
                    this.addAutocompleteCheckbox(selectedItem, searchText);
                    addedIds.push(selectedItem.id);
                    addedCounter++;
                }

                if (addedCounter >= limit)
                {
                    return false;
                }

                return true;
            });
        }

        return this;
    }


    protected handleLinkRelease(event) : void {
        event.preventDefault();
    }

    protected handleSearchRelease() : void {
        // this.loadingIndicator.loading(true);
        // this.list.setFilters(this.getFiltersForList());
        // this.list.reload();
        // this.container.classList.add("b-SearchBar--results");

        // this.loadingIndicator.loading(false);
    }

    protected uncheckCheckboxAncestor(checkbox: HTMLInputElement): this
    {
        const parentId: string = checkbox.getAttribute("data-parent-id");
        if (!parentId)
            return this;

        const parent: HTMLInputElement = this.searchDropdown.querySelector(`.m-SearchItem__checkbox input[data-id="${parentId}"]`);

        if (parent)
        {
            parent.checked = false;
            this.updateItemData(parseInt(parentId), {checked: false});
            this.uncheckCheckboxAncestor(parent);
        }

        return this;
    }

    protected maybeCheckAncestor(checkbox: HTMLInputElement): this
    {
        const parentId: string = checkbox.getAttribute("data-parent-id");

        if (!parentId)
            return this;

        const parent: HTMLInputElement = this.searchDropdown.querySelector(`.m-SearchItem__checkbox input[data-id="${parentId}"]`);

        if (!parent)
            return this;

        const searchItemField: HTMLElement = parent.closest(".m-SearchItem");

        const childrenInputs: NodeListOf<HTMLInputElement> = searchItemField.querySelectorAll(".m-SearchItem__children .m-SearchItem__checkbox input");

        let allChecked: boolean = true;

        for (let i: number = 0; i < childrenInputs.length; i++)
        {
            const input: HTMLInputElement = childrenInputs[i];

            //strange bug
            if (input === parent)
                continue;

            if (!input.checked)
            {
                allChecked = false;
                break;
            }
        }

        if (allChecked)
        {
            parent.checked = true;
            this.updateItemData(parseInt(parentId), {checked: true});
            this.maybeCheckAncestor(parent);
        }

        return this;
    }

    protected updateSelectedChildrenIndicator(checkbox: HTMLInputElement): this
    {
        const isChecked: boolean = checkbox.checked;
        const searchItem: HTMLElement = checkbox.closest(".m-SearchItem");
        const id: string = checkbox.getAttribute("data-id");
        const childrenInputs: NodeListOf<HTMLInputElement> = searchItem.querySelectorAll(".m-SearchItem__children .m-SearchItem__checkbox input");

        let someChildrenChecked: boolean = false;

        for (let i: number = 0; i < childrenInputs.length; i++)
        {
            const input: HTMLInputElement = childrenInputs[i];

            //strange bug
            if (input === checkbox)
                continue;

            if (input.checked)
            {
                someChildrenChecked = true;
                break;
            }
        }

        if (!someChildrenChecked)
        {
            for (let i: number = 0; i < childrenInputs.length; i++)
            {
                const input: HTMLInputElement = childrenInputs[i];
                const item: HTMLElement = input.closest(".m-SearchItem");

                if (!isChecked)
                {
                    item.classList.remove("m-SearchItem--children-selected");
                }
            }
        }

        searchItem.classList.remove("m-SearchItem--children-selected");

        if (!isChecked && someChildrenChecked)
        {
            searchItem.classList.add("m-SearchItem--children-selected");
        }

        const parentId: string = checkbox.getAttribute("data-parent-id");
        const parentInput: HTMLInputElement = this.searchDropdown.querySelector(`.m-SearchItem__checkbox input[data-id="${parentId}"]`);

        if (parentInput)
        {
            this.updateSelectedChildrenIndicator(parentInput);
        }

        return this;
    }

    protected updateChildrenAndAncestors(checkbox: Checkbox, check: boolean, updateChildren: boolean = true): this
    {
        const isChecked: boolean = check;
        const searchItemField: HTMLElement = checkbox.getElement().closest(".m-SearchItem");
        const checkboxId: string = checkbox.getInput().getAttribute("data-id");
        const fieldChildren: NodeListOf<HTMLInputElement> = searchItemField.querySelectorAll(".m-SearchItem__children .m-SearchItem__checkbox input");

        // check/uncheck children
        if (updateChildren)
        {
            fieldChildren.forEach((checkbox: HTMLInputElement) =>
            {
                checkbox.checked = isChecked;
                this.updateItemData(parseInt(checkbox.getAttribute("data-id")), {checked: isChecked});
            });
        }

        // uncheck ancestors if checked == false
        if (!isChecked)
        {
            this.uncheckCheckboxAncestor(checkbox.getInput());
        }
        else
            // check if all children checked
        {
            this.maybeCheckAncestor(checkbox.getInput());
        }

        this.updateSelectedItemsList();

        // this.updateDropdownText(dropdownName);


        // if (target.isChecked())
        // console.log("selected filter: ", target.getInput().name);

        return this;
    }

    protected handleHierarchyCheckboxChange(event) : void {
        const target: Checkbox = event.detail.target;
        const targetId: string = target.getInput().getAttribute("data-id");

        this.updateItemData(parseInt(targetId), {checked: target.isChecked()});
        this.updateChildrenAndAncestors(target, target.isChecked());
        this.updateSelectedChildrenIndicator(target.getInput());
        this.updateDropdownText();

        // this.updateDropdownText(dropdownName);


        // if (target.isChecked())
            // console.log("selected filter: ", target.getInput().name);

    }

    protected handleSelectedCheckboxChange(event) : void {
        const target: Checkbox = event.detail.target;
        const targetId: string = target.getInput().getAttribute("data-id");
        const hierarchyCheckbox: Checkbox = this.checkboxes.get(targetId);

        hierarchyCheckbox.setChecked(target.isChecked()); //false
        this.updateChildrenAndAncestors(hierarchyCheckbox, target.isChecked());

    }

    protected handleSearchResultsCheckboxChange(event) : void {
        const target: Checkbox = event.detail.target;
        const targetId: string = target.getInput().getAttribute("data-id");
        const hierarchyCheckbox: Checkbox = this.checkboxes.get(targetId);

        hierarchyCheckbox.setChecked(target.isChecked());
        // this.updateChildrenAndAncestors(hierarchyCheckbox, target.isChecked());
    }

    protected handleDataReady(event): void
    {
        if (event.data)
        {
            this.buildSearch(event.data);
        }
    }

    protected handleSearchInputChange(event): void
    {
        this.updateSearchResults(event.target.value);
    }

    protected handleSearchInputBlur(event): void
    {
        // this.showHierarchyAndSelected();
    }

    protected handleSearchInputFocus(event): void
    {
        if (event.target.value.length > 0)
            this.showAutocomplete();
        else
            this.showHierarchyAndSelected();
    }
}

